module.exports = __webpack_public_path__ + "static/media/profile.b18bdbea.jpeg";